<template>
  <div class="home">
    <!-- 顶部绿色横幅 -->
    <!-- <section class="green-hero-banner">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="hero-left">
          <h2 class="hero-title">推动绿色技术创新 · 促进绿色产品应用</h2>
          <h2 class="hero-title mt-2">分享绿色采购经验 · 推动供应链绿色转型</h2>
        </div>
        <div class="hero-right">
          <div class="hero-icon icon-large">
            <div class="pulse-ring"></div>
            <div class="inner-ring"></div>
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z"></path></svg>
          </div>
          <div class="hero-icon icon-medium">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" opacity="0.3"></path><path d="M8 12l3 3 5-5" stroke-width="2"></path><path d="M16 6v6h-6" stroke-width="2"></path><path d="M8 18v-6h6" stroke-width="2"></path></svg>
          </div>
          <div class="hero-icon icon-small">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z"></path></svg>
          </div>
        </div>
      </div>
    </section> -->
    <!-- 大轮播图 -->
    <section class="home-banner" v-if="bigBannerList.length > 0">
      <div class="swiper-container big-swiper" ref="bigSwiper">
        <div class="swiper-wrapper">
          <div v-for="(banner, index) in bigBannerList" :key="banner.id || index" class="swiper-slide">
            <a :href="banner.url" target="_blank" v-if="banner.url" class="banner-link">
              <img :src="banner.attachmentUrl" :alt="banner.name" class="banner-img" />
            </a>
            <img v-else :src="banner.attachmentUrl" :alt="banner.name" class="banner-img" />
          </div>
        </div>
        <!-- 分页器：用固定 id 绑定，避免 ref 时机导致 Swiper 未挂上分页 -->
        <div v-show="bigBannerList.length > 1" id="home-big-banner-pagination" ref="bigSwiperPagination"
          class="swiper-pagination big-swiper-pagination"></div>
      </div>
    </section>
    <!-- Banner 区域 -->
    <section class="banner-section">
      <!-- <div class="banner-main">
        <div class="banner-content">
          <div class="banner-left">
            <div class="banner-slider">
              <div v-for="(banner, index) in smallBannerList" :key="index" v-show="currentSlide === index"
                class="slider-item">
                <a :href="banner.url" target="_blank" v-if="banner.url">
                  <img :src="banner.attachmentUrl" :alt="banner.name" class="slider-img" />
                </a>
                <img v-else :src="banner.attachmentUrl" :alt="banner.name" class="slider-img" />
              </div>
              <div class="slider-dots" v-if="smallBannerList.length > 1">
                <span v-for="(banner, index) in smallBannerList" :key="index"
                  :class="['dot', { active: currentSlide === index }]" @click="goToSlide(index)"></span>
              </div>
            </div>
          </div>

          <div class="banner-right">
            <div class="news-tabs">
              <div :class="['tab-item', { active: activeNewsTab === 0 }]" @click="switchNewsTab(0)">政策法规</div>
              <div :class="['tab-item', { active: activeNewsTab === 1 }]" @click="switchNewsTab(1)">要闻动态</div>
            </div>
            <div v-if="newsLoading" class="news-loading">
              <span>加载中...</span>
            </div>

            <div v-else class="news-list">
              <div v-for="(news, index) in newsList" :key="index" class="news-item" @click="goToNewsDetail(news.id)">
                <span class="news-dot">•</span>
                <span class="news-title">{{ news.title }}</span>
                <span class="news-date">{{ news.date }}</span>
              </div>
            </div>
            <div class="news-more">
              <a @click="goToNewsList">更多>></a>
            </div>
          </div>
        </div>
      </div> -->
      <div class="banner-buttons-wrapper">
        <div class="banner-buttons" :class="{ 'is-sticky': isButtonsSticky }" ref="bannerButtons">
          <button
            v-for="(btn, index) in ['绿色报告', '绿色案例']"
            :key="index"
            type="button"
            :class="['tab-item', { active: activeTab === index }]"
            @click="switchTab(index)"
          >
            {{ btn }}
          </button>
        </div>
        <div v-if="isButtonsSticky" class="buttons-placeholder"></div>
      </div>
    </section>

    <!-- 内容区域 -->
    <div class="content-area">

      <!-- 绿色报告内容 -->
      <div v-show="activeTab === 0" class="tab-content">
        <!-- 报告查询 + 报告类型 -->
        <section id="green-report" class="report-section" ref="greenReport">
          <div class="card-wrapper">
            <div class="report-search-box">
              <div class="search-title">
                <span class="icon-search"></span>
                <h3>报告查询</h3>
              </div>
              <div class="search-form">
                <div class="form-row">
                  <div class="form-item">
                    <label>企业全称</label>
                    <input v-model="searchForm.companyName" type="text" placeholder="请输入企业全称">
                  </div>
                  <div class="form-item">
                    <label>查询秘钥</label>
                    <input v-model="searchForm.key" type="text" placeholder="请输入查询秘钥">
                  </div>
                  <button class="btn-search" @click="handleSearch">查询</button>
                </div>
                <p class="search-tips">免责声明：报告信息来源于第三方报告编制机构，并由其对报告内容负责，查询结果仅供参考。</p>
              </div>

              <!-- 查询结果 -->
              <div v-if="showResults" class="search-results">
                <h4 class="results-title">查询结果</h4>

                <!-- 加载中 -->
                <div v-if="reportLoading" class="loading-state">
                  <p>查询中...</p>
                </div>

                <!-- 错误提示 -->
                <div v-else-if="reportError" class="error-state">
                  <p>{{ reportError }}</p>
                  <button @click="handleSearch">重新查询</button>
                </div>

                <!-- 结果表格 -->
                <template v-else-if="reportResults.length > 0">
                  <div class="results-table-wrap">
                    <table class="results-table">
                      <thead>
                        <tr>
                          <th>单位名称</th>
                          <th>报告名称</th>
                          <th>报告编号</th>
                          <th>编制标准</th>
                          <th>报告有效期</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in reportResults" :key="index">
                          <td :title="item.applyUnit || item.company">{{ item.applyUnit || item.company }}</td>
                          <td class="report-name">
                            <a
                              :href="item.reportUrl || item.reportLink"
                              target="_blank"
                              class="report-link"
                              :title="item.reportName"
                            >{{ item.reportName }}</a>
                          </td>
                          <td :title="item.reportNumber">{{ item.reportNumber }}</td>
                          <td class="standard">
                            <a
                              :href="item.enterpriseStandardLink"
                              target="_blank"
                              class="standard-link"
                              :title="item.enterpriseStandard"
                            >{{ item.enterpriseStandard }}</a>
                          </td>
                          <td class="validity-cell">{{ formatReportValidityRange(item) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- 分页 -->
                  <div v-if="reportTotalPages > 1" class="results-pagination">
                    <button class="page-btn" @click="reportPrevPage" :disabled="reportCurrentPage === 1">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                    <button
                      v-for="page in reportTotalPages"
                      :key="page"
                      :class="['page-num', { active: reportCurrentPage === page }]"
                      @click="reportGoToPage(page)"
                    >
                      {{ page }}
                    </button>
                    <button class="page-btn" @click="reportNextPage" :disabled="reportCurrentPage === reportTotalPages">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </template>

                <!-- 空结果 -->
                <div v-else class="empty-state">
                  <p>未找到相关报告，请检查输入信息</p>
                </div>
              </div>
            </div>

            <div class="report-types-part">
            <h3 class="section-title">
              <span class="title-bar"></span>
              报告类型
            </h3>
            <div class="report-types-grid">
              <div v-for="(type, index) in reportTypes" :key="index" class="type-card">
                <div class="type-icon" v-html="type.icon"></div>
                <h4>{{ type.title }}</h4>
                <p>{{ type.desc }}</p>
              </div>
            </div>
            </div>
          </div>
        </section>

        <!-- 编制标准 -->
        <section class="standards-section">
          <div class="card-wrapper">
            <h3 class="section-title">
              <span class="title-bar"></span>
              编制标准
            </h3>
            <div class="standards-notice">
              <p>依据国家/行业/企业标准编制（采用的企业标准已在国家市场监督管理总局企业标准信息公共服务平台声明公开并接受监督）</p>
            </div>
            <div class="standards-list">
              <div v-for="(item, index) in standards" :key="item.title || index" class="standard-item">
                <div class="standard-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <a v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer" class="standard-item-link">{{
                  item.title }}</a>
                <span v-else>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </section>

        <!-- 覆盖行业 -->
        <section class="industries-section">
          <div class="card-wrapper">
            <h3 class="section-title">
              <span class="title-bar"></span>
              覆盖行业
            </h3>
            <div class="industries-grid">
              <div v-for="(industry, index) in industries" :key="index" class="industry-card">
                <div class="industry-icon" v-html="industry.icon"></div>
                <span>{{ industry.name }}</span>
              </div>
            </div>
          </div>
        </section>

        <!-- 价值赋能 -->
        <section class="value-section">
          <div class="card-wrapper">
            <h3 class="section-title">
              <span class="title-bar"></span>
              价值赋能
            </h3>
            <div class="value-cards">
              <div v-for="(card, index) in valueCards" :key="index" class="value-card">
                <div class="value-header">
                  <span class="value-tag">{{ card.tag }}</span>
                  <h4 :title="card.title">{{ card.title }}</h4>
                </div>
                <div class="value-body">
                  <p class="case-title">{{ card.caseTitle }}</p>
                  <p class="case-desc">{{ card.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


      <!-- 绿色案例内容 -->
      <div v-show="activeTab === 1" class="tab-content">
        <section class="case-section" ref="greenCase">
          <div class="case-wrapper">
            <div class="case-content">
              <!-- 左侧：绿色供应链全周期 -->
              <div class="case-left">
                <h3 class="section-title">
                  <span class="title-bar"></span>
                  绿色供应链全周期
                </h3>
                <div class="lifecycle-chart">
                  <svg class="lifecycle-ring" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid meet">
                    <defs>
                      <linearGradient id="caseRingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stop-color="#10b981" stop-opacity="0.15"></stop>
                        <stop offset="50%" stop-color="#059669" stop-opacity="0.15"></stop>
                        <stop offset="100%" stop-color="#10b981" stop-opacity="0.15"></stop>
                      </linearGradient>
                    </defs>
                    <circle cx="200" cy="200" r="140" fill="none" stroke="url(#caseRingGradient)" stroke-width="50"></circle>
                    <circle cx="200" cy="200" r="140" fill="none" stroke="#10b981" stroke-width="2"
                      stroke-dasharray="15 50" class="animate-spin-ring"></circle>
                  </svg>
                  <div class="lifecycle-center">
                    <div class="center-circle">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"></path>
                        <path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"></path>
                        <path d="m14 16-3 3 3 3"></path>
                        <path d="M8.293 13.596 7.196 9.5 3.1 10.598"></path>
                        <path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"></path>
                        <path d="m13.378 9.633 4.096 1.098 1.097-4.096"></path>
                      </svg>
                      <span class="center-text">循环</span>
                    </div>
                  </div>
                  <div class="lifecycle-nodes">
                    <div class="node node-top">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                          <path d="M17 18h1"></path><path d="M12 18h1"></path><path d="M7 18h1"></path>
                        </svg>
                      </div>
                      <span class="node-label">生产</span>
                    </div>
                    <div class="node node-right-top">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"></path>
                          <path d="M12 22V12"></path><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"></path><path d="m7.5 4.27 9 5.15"></path>
                        </svg>
                      </div>
                      <span class="node-label">包装</span>
                    </div>
                    <div class="node node-right">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
                          <path d="M15 18H9"></path>
                          <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                          <circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle>
                        </svg>
                      </div>
                      <span class="node-label">物流</span>
                    </div>
                    <div class="node node-right-bottom">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle>
                          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
                        </svg>
                      </div>
                      <span class="node-label">销售</span>
                    </div>
                    <div class="node node-left-bottom">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="m11 17 2 2a1 1 0 1 0 3-3"></path>
                          <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
                          <path d="m21 3 1 11h-2"></path><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path><path d="M3 4h8"></path>
                        </svg>
                      </div>
                      <span class="node-label">服务</span>
                    </div>
                    <div class="node node-left">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                          <path d="M12 9v4"></path><path d="M12 17h.01"></path>
                        </svg>
                      </div>
                      <span class="node-label">回收</span>
                    </div>
                    <div class="node node-left-top">
                      <div class="node-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                      </div>
                      <span class="node-label">再利用</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧：征集实践成果 -->
              <div class="case-right">
                <div class="case-info-card">
                  <div class="info-header">
                    <div class="info-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path
                          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                    </div>
                    <h4>征集招标采购与供应链应用绿色创新实践成果</h4>
                  </div>
                  <p class="info-desc">
                    围绕绿色管理赋能行业高质量发展，遴选创新性强、应用性好、示范价值高、推广前景广的绿色优秀产品、解决方案、平台工具和典型案例，推动形成可复制、可推广的绿色实践成果，促进招标采购与供应链绿色转型升级。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- 联系我们（公共部分） -->
      <section class="contact-section">
        <div class="card-wrapper">
          <h3 class="section-title">
            <span class="title-bar"></span>
            联系我们
          </h3>
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <div class="contact-detail">
                <label>联系电话</label>
                <p class="phone">010-88484118-815</p>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <div class="contact-detail">
                <label>工作时间</label>
                <p>工作日 9:00-18:00</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import { getNewsList, getReportList, getBannerList } from '../api'
import Swiper from 'swiper'
import { Autoplay, Pagination, EffectFade } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

export default {
  name: 'Home',
  data() {
    return {
      activeTab: 0, // 0: 绿色报告, 1: 绿色案例
      isButtonsSticky: false,

      // 小轮播图数据
      currentSlide: 0,
      sliderTimer: null,
      smallBannerList: [],

      // 大轮播图数据
      bigBannerList: [],
      bigSwiper: null,

      // 新闻Tab数据
      activeNewsTab: 0,
      newsList: [],
      newsLoading: false,

      searchForm: {
        companyName: '',
        key: ''
      },
      showResults: false,
      reportResults: [],
      reportLoading: false,
      reportError: null,
      reportCurrentPage: 1,
      reportPageSize: 10,
      reportTotal: 0,
      reportTypes: [
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path><circle cx="12" cy="8" r="6"></circle></svg>`, title: 'ESG专项报告', desc: '包含聚焦环境、社会和公司治理维度的ESG专项报告，是企业相关责任与治理的呈现载体' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path><path d="M9 18h6"></path><path d="M10 22h4"></path></svg>`, title: '创新类核心报告', desc: '涵盖创新激励机制、科研经费占比、企业创新成果、研发团队规模等多维度的创新相关报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>`, title: '生产创新专项报告', desc: '包含生产技术和工艺创新、设备工艺优化改进报告，聚焦生产环节的创新实践与成果' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>`, title: '综合规划类报告', desc: '包含绿色发展规划报告、绿色发展顶层规划报告、绿色发展顶层规划和执行情况报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path></svg>`, title: '节能降碳类报告', desc: '涵盖能耗降低方案报告、绿色电力使用情况报告、产品碳足迹及核算报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path><path d="M17 18h1"></path><path d="M12 18h1"></path><path d="M7 18h1"></path></svg>`, title: '产业实践类报告', desc: '涉及绿色物流、回收、制造、包装报告及原材料组部件改进报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect><path d="M9 22v-4h6v4"></path><path d="M8 6h.01"></path><path d="M16 6h.01"></path><path d="M12 6h.01"></path><path d="M12 10h.01"></path><path d="M12 14h.01"></path><path d="M16 10h.01"></path><path d="M16 14h.01"></path><path d="M8 10h.01"></path><path d="M8 14h.01"></path></svg>`, title: '经营状况类报告', desc: '包含企业经营状况综合评价报告、综合绩效报告、运行绩效报告、规模与服务评价报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>`, title: '管控履约类报告', desc: '包含供应链保障措施报告、质量管控措施报告、企业履约能力报告、售后服务能力评价报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>`, title: '投标响应类报告', desc: '包含投标响应综合评价报告，作为经营与管控类报告的专项组成部分' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>`, title: '合规应对类报告', desc: '包含实体清单应对举措、自主可控水平、应急保供评价、应对国际贸易壁垒举措报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>`, title: '智造建设类报告', desc: '涵盖数字化车间、未来工厂、智能工厂、数字领航企业、智能制造示范工厂及优秀场景方案报告' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>`, title: '其他品类报告', desc: '更多报告类型持续更新中...' }
      ],
      standards: [
        {
          title: 'ESG报告编制策划与项目管理规范',
          url: 'https://www.qybz.org.cn/user/detail/03c49d413cc8c1d5104a0c29449f1fe0b7275233de99664fd23e5585e0e821571667e8270e92630f8ddeed1ee4fdb693'
        },
        {
          title: '绿色发展顶层规划及执行情况报告编制规范',
          url: 'https://www.qybz.org.cn/user/detail/b5a89f05aad3a778894876b2bab2d27437862ec6cb1e69cd16e99398bbd012b91667e8270e92630f8ddeed1ee4fdb693'
        },
        {
          title: '数字化车间方案报告编制规范',
          url: 'https://www.qybz.org.cn/user/detail/5f0a85c96b1f47adc5002ee9bd7989c985ab81fddc1c5559d9a68600ab6415f51667e8270e92630f8ddeed1ee4fdb693'
        }
      ],
      industries: [
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path><path d="M17 18h1"></path><path d="M12 18h1"></path><path d="M7 18h1"></path></svg>`, name: '电力服务行业' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect><path d="M9 22v-4h6v4"></path><path d="M8 6h.01"></path><path d="M16 6h.01"></path><path d="M12 6h.01"></path><path d="M12 10h.01"></path><path d="M12 14h.01"></path><path d="M16 10h.01"></path><path d="M16 14h.01"></path><path d="M8 10h.01"></path><path d="M8 14h.01"></path></svg>`, name: '电力建筑行业' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>`, name: '电力物资行业' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>`, name: '能源行业' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path></svg>`, name: '数字化与信息化行业' },
        { icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>`, name: '社会公用及其他行业' }
      ],
      valueCards: [
        {
          tag: '绿色发展规划报告',
          title: '构建全周期、系统化绿色发展体系',
          caseTitle: '典型案例：',
          desc: '中国某建设集团通过系统化的规划设计，成功将绿色发展从"被动合规"转化为"主动赋能"，响应了国家"双碳"目标，为能源企业绿色转型提供了可复制、可推广的实践范本。'
        },
        {
          tag: '原材料组部件改进评价报告',
          title: '实现"产品-生产-市场-发展"全链条价值提升',
          caseTitle: '典型案例：',
          desc: '北京某科技有限公司通过技术、工艺、材料系统性优化方案，将分散的创新成果系统化、模糊的改进方向清晰化，推动企业发展模式变革，加速从"产品制造商"向"技术创新型企业"转型升级。'
        },
        {
          tag: 'ESG管理报告',
          title: '推动环境、社会、治理效益协同释放',
          caseTitle: '典型案例：',
          desc: '江苏某电力建设有限公司通过ESG专项报告完成了实践梳理、数据量化、成果展示的基础目标，实现从"零散实践"到"体系化运营"的跨越，助力企业以可持续发展能力赋能行业高质量发展。'
        }
      ]
    }
  },

  computed: {
    newsType() {
      // 2=政策法规, 1=要闻动态
      return this.activeNewsTab === 0 ? 2 : 1
    },
    reportTotalPages() {
      return Math.ceil(this.reportTotal / this.reportPageSize) || 1
    }
  },

  mounted() {
    this.fetchBannerList()
    window.addEventListener('scroll', this.handleScroll)
    this.fetchHomeNews()
  },

  beforeDestroy() {
    this.stopSlider()
    if (this.bigSwiper) {
      this.bigSwiper.destroy()
    }
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    // 报告查询
    async handleSearch() {
      // 表单验证
      if (!this.searchForm.companyName.trim()) {
        alert('请输入企业全称')
        return
      }
      if (!this.searchForm.key.trim()) {
        alert('请输入查询秘钥')
        return
      }

      this.reportCurrentPage = 1
      await this.fetchReportList()
    },

    async fetchReportList() {
      this.reportLoading = true
      this.reportError = null
      this.showResults = true

      try {
        const params = {
          applyUnit: this.searchForm.companyName,
          verifyCode: this.searchForm.key,
          current: this.reportCurrentPage,
          size: this.reportPageSize
        }

        const res = await getReportList(params)

        if (res.code === 200 || res.code === 0) {
          this.reportResults = res.rows || res.data?.records || res.data?.list || res.data || []
          this.reportTotal = res.total || res.data?.total || this.reportResults.length
          if (this.reportResults.length === 0 && this.reportCurrentPage === 1) {
            this.reportError = '未找到相关报告，请检查企业名称和查询秘钥'
          }
        } else {
          this.reportError = res.msg || res.message || '查询失败'
        }
      } catch (error) {
        console.error('报告查询失败:', error)
        this.reportError = '网络请求失败，请稍后重试'
      } finally {
        this.reportLoading = false
      }
    },

    reportPrevPage() {
      if (this.reportCurrentPage > 1) {
        this.reportCurrentPage--
        this.fetchReportList()
      }
    },

    reportNextPage() {
      if (this.reportCurrentPage < this.reportTotalPages) {
        this.reportCurrentPage++
        this.fetchReportList()
      }
    },

    reportGoToPage(page) {
      if (page !== this.reportCurrentPage) {
        this.reportCurrentPage = page
        this.fetchReportList()
      }
    },

    formatDateChineseYMD(value) {
      if (value == null || value === '') return ''
      const s = String(value).trim()
      let m = s.match(/(\d{4})-(\d{1,2})-(\d{1,2})/)
      if (!m) m = s.match(/(\d{4})\/(\d{1,2})\/(\d{1,2})/)
      if (m) {
        return `${m[1]}年${String(m[2]).padStart(2, '0')}月${String(m[3]).padStart(2, '0')}日`
      }
      const d = new Date(s.replace(/-/g, '/'))
      if (Number.isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const mo = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}年${mo}月${day}日`
    },

    formatReportValidityRange(row) {
      const start = this.formatDateChineseYMD(row.disclosureDate)
      const end = this.formatDateChineseYMD(row.expiryDate)
      if (start && end) return `${start}至${end}`
      if (start) return start
      if (end) return end
      return '—'
    },

    // 吸顶判断
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const bannerSection = document.querySelector('.banner-section')
      if (bannerSection) {
        const bannerBottom = bannerSection.offsetTop + bannerSection.offsetHeight
        this.isButtonsSticky = scrollTop > bannerBottom - 50
      }
    },

    // Tab切换
    switchTab(index) {
      this.activeTab = index
      // 等待 DOM 更新后滚动到对应区域
      this.$nextTick(() => {
        let targetRef = null
        if (index === 0) targetRef = this.$refs.greenReport
        else if (index === 1) targetRef = this.$refs.greenCase

        if (targetRef) {
          const offsetTop = targetRef.offsetTop - 80 // 预留顶部空间
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          })
        }
      })
    },

    // 获取轮播图列表
    async fetchBannerList() {
      try {
        // 获取大轮播图
        const bigBannerRes = await getBannerList({ bannerType: 1 })
        if (bigBannerRes.code === 200 || bigBannerRes.code === 0) {
          this.bigBannerList = bigBannerRes.data || []
          if (this.bigBannerList.length > 0) {
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.initBigSwiper()
              })
            })
          }
        }

        // 获取小轮播图
        const smallBannerRes = await getBannerList({ bannerType: 2 })
        if (smallBannerRes.code === 200 || smallBannerRes.code === 0) {
          this.smallBannerList = smallBannerRes.data || []
          if (this.smallBannerList.length > 0) {
            this.startSlider()
          }
        }
      } catch (error) {
        console.error('获取轮播图失败:', error)
      }
    },

    initBigSwiper() {
      if (this.bigSwiper) {
        this.bigSwiper.destroy(true, true)
        this.bigSwiper = null
      }
      const el = this.$refs.bigSwiper
      if (!el) return

      const multiple = this.bigBannerList.length > 1
      const paginationEl =
        document.getElementById('home-big-banner-pagination') ||
        this.$refs.bigSwiperPagination

      this.bigSwiper = new Swiper(el, {
        modules: [Autoplay, Pagination, EffectFade],
        loop: multiple,
        // fade 模式下 snapGrid 常只有一项，watchOverflow 会把 isLocked 判为 true，
        // 分页会被加上 swiper-pagination-lock（display:none），小点会「消失」
        watchOverflow: false,
        grabCursor: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoHeight: false,
        on: {
          imagesReady: () => {
            this.$nextTick(() => {
              if (this.bigSwiper) this.bigSwiper.update()
            })
          },
          slideChangeTransitionEnd: () => {
            this.$nextTick(() => {
              if (this.bigSwiper) this.bigSwiper.update()
            })
          }
        },
        autoplay: multiple
          ? {
            delay: 4500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
          : false,
        pagination: multiple && paginationEl
          ? {
            el: paginationEl,
            type: 'bullets',
            clickable: true
          }
          : undefined
      })
    },

    // 小轮播图控制
    startSlider() {
      this.sliderTimer = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },

    stopSlider() {
      if (this.sliderTimer) {
        clearInterval(this.sliderTimer)
        this.sliderTimer = null
      }
    },

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.smallBannerList.length
    },

    goToSlide(index) {
      this.currentSlide = index
      this.stopSlider()
      this.startSlider()
    },

    // Tab切换
    // 获取首页新闻列表
    async fetchHomeNews() {
      this.newsLoading = true
      try {
        const params = {
          newsType: this.newsType,
          current: 1,
          size: 5  // 首页只显示前5条
        }
        const res = await getNewsList(params)

        if (res.code === 200 || res.code === 0) {
          const list = res.rows || res.data?.records || res.data?.list || res.data || []
          // 格式化数据
          this.newsList = list.map(item => ({
            id: item.id,
            title: item.title,
            date: item.publishTime || item.date || item.publishDate || item.createTime
          }))
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error)
      } finally {
        this.newsLoading = false
      }
    },

    switchNewsTab(index) {
      this.activeNewsTab = index
      this.fetchHomeNews()
    },

    // 跳转到新闻详情页
    goToNewsDetail(id) {
      const routeUrl = this.$router.resolve({
        path: `/news/${id}`
      })
      window.open(routeUrl.href, '_blank')
    },

    // 跳转到新闻列表页
    goToNewsList() {
      const type = this.activeNewsTab === 0 ? 'policy' : 'dynamic'
      const routeUrl = this.$router.resolve({
        path: '/news',
        query: { type }
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
// 大轮播图
.home-banner {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: none;
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
  }

  .big-swiper {
    width: 100%;
    height: 215px;
    position: relative;

    @media (max-width: 768px) {
      height: auto;
      aspect-ratio: 5 / 1;
      min-height: 100px;
      box-sizing: border-box;
    }

    ::v-deep .swiper-wrapper {
      display: flex;
      width: 100%;
      height: 100%;
    }


    .swiper-slide {
      width: 100%;
      height: 100%;
      flex-shrink: 0;

      .banner-link {
        display: block;
        width: 100%;
        height: 100%;
      }

      .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
      }
    }

    @media (max-width: 768px) {
      .swiper-slide {
        position: relative;
        overflow: hidden;
        height: 100%;

        .banner-link {
          position: relative;
          height: 100%;
          min-height: 100%;
        }

        .banner-img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center center;
          display: block;
        }
      }
    }

    .swiper-pagination {
      bottom: 20px !important;
      left: 0;
      right: 0;
      width: 100%;
      text-align: center;
      z-index: 30 !important;
      pointer-events: auto;

      @media (max-width: 768px) {
        bottom: 10px !important;
        line-height: 1;
        padding-top: 4px;
      }

      ::v-deep .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        opacity: 1;
        transition: transform 0.25s ease, background 0.25s ease, border-color 0.25s ease;
      }

      ::v-deep .swiper-pagination-bullet-active {
        background: #22c55e;
        border-color: #22c55e;
        transform: scale(1.25);
      }

      ::v-deep .swiper-pagination-bullet-active-main {
        background: #22c55e;
        border-color: #22c55e;
      }
    }
  }
}

// 顶部绿色横幅
.green-hero-banner {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #15803d 0%, #16a34a 50%, #22c55e 100%);
  height: 280px;

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, rgba(21, 128, 61, 0.9), rgba(34, 197, 94, 0.8));
  }

  .hero-content {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100%;
    display: flex;
    align-items: center;

    .hero-left {
      flex: 1;

      .hero-title {
        font-size: 28px;
        font-weight: 700;
        color: white;
        line-height: 1.5;
        margin: 0;

        &.mt-2 {
          margin-top: 8px;
        }
      }
    }

    .hero-right {
      display: flex;
      align-items: center;
      gap: 24px;

      .hero-icon {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.8);

        &.icon-large {
          width: 128px;
          height: 128px;

          .pulse-ring {
            position: absolute;
            inset: 0;
            border-radius: 50%;
            border: 4px solid rgba(255, 255, 255, 0.3);
            animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }

          .inner-ring {
            position: absolute;
            inset: 16px;
            border-radius: 50%;
            border: 4px solid rgba(255, 255, 255, 0.2);
          }

          svg {
            width: 64px;
            height: 64px;
          }
        }

        &.icon-medium {
          width: 96px;
          height: 96px;

          svg {
            width: 96px;
            height: 96px;
          }
        }

        &.icon-small {
          width: 80px;
          height: 80px;

          svg {
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

// Banner 区域
.banner-section {
  background: white;
  padding: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  .banner-main {
    background: #fff;
    padding: 30px 0;

    .banner-content {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
      gap: 30px;
      align-items: stretch;

      .banner-left {
        flex: 0.8;

        .banner-slider {
          position: relative;

          .slider-item {
            animation: fadeIn 0.5s ease-in-out;

            @keyframes fadeIn {
              from {
                opacity: 0;
              }

              to {
                opacity: 1;
              }
            }

            .slider-img {
              width: 478px;
              height: 268px;
              object-fit: cover;
              border-radius: 8px;
              display: block;
            }

            @media (max-width: 768px) {
              .slider-img {
                width: 100%;
                height: auto;
              }
            }

            .slider-image {
              position: relative;
              border-radius: 8px;
              overflow: hidden;

              .eco-image-placeholder {
                width: 100%;
                height: 280px;
                background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;

                .eco-visual {
                  position: relative;
                  width: 200px;
                  height: 200px;

                  .earth-circle {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100px;
                    height: 100px;
                    background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 50px;
                    box-shadow: 0 4px 20px rgba(22, 163, 74, 0.3);
                  }

                  .leaf {
                    position: absolute;
                    font-size: 24px;

                    &.leaf-1 {
                      top: 10px;
                      left: 20px;
                    }

                    &.leaf-2 {
                      top: 30px;
                      right: 30px;
                    }
                  }

                  .windmill {
                    position: absolute;
                    bottom: 20px;
                    left: 30px;
                    font-size: 30px;
                  }

                  .solar {
                    position: absolute;
                    bottom: 30px;
                    right: 20px;
                    font-size: 28px;
                  }
                }
              }

              .slider-text {
                position: absolute;
                top: 20px;
                left: 20px;
                color: #166534;

                h3 {
                  font-size: 18px;
                  font-weight: 600;
                  line-height: 1.4;
                  margin-bottom: 5px;
                }

                .year {
                  font-size: 14px;
                  color: #16a34a;
                }
              }
            }
          }

          .slider-dots {
            display: flex;
            justify-content: center;
            gap: 8px;
            margin-top: 15px;

            .dot {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #d1d5db;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background-color: #86efac;
              }

              &.active {
                background-color: #22c55e;
                transform: scale(1.2);
              }
            }
          }
        }
      }

      .banner-right {
        flex: 1;
        background: white;
        border-radius: 8px;
        padding: 0px 20px 0px 20px;
        display: flex;
        flex-direction: column;

        .news-tabs {
          display: flex;
          gap: 40px;
          border-bottom: 1px solid #e5e7eb;
          margin-bottom: 15px;

          .tab-item {
            padding: 0px 0px 10px 0px;
            font-size: 18px;
            color: #666;
            cursor: pointer;
            position: relative;
            transition: all 0.3s;
            font-weight: bold;

            &:hover {
              color: #16a34a;
            }

            &.active {
              color: #16a34a;

              &::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 0;
                right: 0;
                height: 2px;
                background-color: #16a34a;
              }
            }
          }
        }

        .news-loading {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #9ca3af;
        }

        .news-list {
          flex: 1;

          .news-item {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px 0;
            border-bottom: 1px dashed #e5e7eb;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              .news-title {
                color: #16a34a;
              }
            }

            &:last-child {
              border-bottom: none;
            }

            .news-dot {
              color: #22c55e;
              font-size: 12px;
            }

            .news-title {
              flex: 1;
              font-size: 14px;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transition: color 0.3s;
              max-width: 525px;
            }

            .news-date {
              font-size: 14px;
              color: #999;
              flex-shrink: 0;
            }
          }
        }

        .news-more {
          text-align: right;

          a {
            font-size: 14px;
            color: #22c55e;
            text-decoration: none;
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }

  .banner-buttons-wrapper {
    position: relative;

    .banner-buttons {
      max-width: 100%;
      margin: 0 auto;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: stretch;
      gap: 0;
      border-bottom: 1px solid #e5e7eb;
      transition: all 0.3s;

      &.is-sticky {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      .tab-item {
        position: relative;
        padding: 14px 35px;
        border: none;
        background: transparent;
        color: #16a34a;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
        cursor: pointer;
        transition: color 0.2s;
        white-space: nowrap;

        // &:hover {
        //   color: #fff;
        // }

        &.active {
          font-weight: 700;
          color: #16a34a;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: calc(100% - 56px);
            max-width: 5em;
            height: 3px;
            background: #16a34a;
            border-radius: 2px 2px 0 0;
          }
        }
      }
    }

    .buttons-placeholder {
      height: 50px;
    }
  }
}

// 内容区域
.content-area {
  min-height: 500px;
}

// 报告查询区域
.report-section {
  padding: 40px 0;
  background-color: #F9FAFB;

  .report-search-box {
    background: white;
    border-radius: 16px;
    padding: 35px 40px;
    box-shadow: 0 4px 20px rgba(22, 163, 74, 0.08);
    border: 1px solid #dcfce7;

    .search-title {
      display: flex;
      align-items: center;
      margin-bottom: 25px;

      .icon-search {
        width: 42px;
        height: 42px;
        background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;

        &::before {
          content: '';
          width: 20px;
          height: 20px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'/%3E%3C/svg%3E");
          background-size: contain;
          background-repeat: no-repeat;
        }
      }

      h3 {
        font-size: 22px;
        color: #1f2937;
        font-weight: 600;
      }
    }

    .search-form {
      .form-row {
        display: flex;
        gap: 15px;
        align-items: flex-end;

        .form-item {
          flex: 1;

          label {
            display: block;
            font-size: 14px;
            color: #374151;
            margin-bottom: 8px;
            font-weight: 500;
            text-indent: 3px;
          }

          input {
            width: 100%;
            padding: 14px 18px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            font-size: 14px;
            background-color: #f9fafb;
            transition: all 0.3s;

            &::placeholder {
              color: #9ca3af;
            }

            &:focus {
              outline: none;
              border-color: #16a34a;
              background-color: white;
              box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
            }
          }
        }

        .btn-search {
          padding: 14px 35px;
          background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 8px;
          height: fit-content;
          margin-bottom: 0;

          &::before {
            content: '';
            width: 16px;
            height: 16px;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='white' stroke-width='2.5'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'/%3E%3C/svg%3E");
            background-size: contain;
            background-repeat: no-repeat;
          }

          &:hover {
            background: linear-gradient(135deg, #15803d 0%, #16a34a 100%);
            box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
            transform: translateY(-1px);
          }
        }
      }

      .search-tips {
        font-size: 14px;
        color: #9ca3af;
        margin-top: 18px;
        display: flex;
        align-items: center;
        gap: 6px;

        &::before {
          content: '';
          width: 14px;
          height: 14px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%239ca3af' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'/%3E%3C/svg%3E");
          background-size: contain;
          background-repeat: no-repeat;
          flex-shrink: 0;
        }
      }
    }

    // 查询结果
    .search-results {
      margin-top: 30px;

      .results-title {
        font-size: 16px;
        color: #333;
        margin-bottom: 15px;
      }

      .results-table-wrap {
        width: 100%;
        overflow: hidden;
      }

      .results-table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;

        th,
        td {
          padding: 12px 15px;
          text-align: left;
          border-bottom: 1px solid #e5e7eb;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        th:nth-child(1),
        td:nth-child(1) {
          width: auto;
        }

        th:nth-child(2),
        td:nth-child(2) {
          width: 200px;
          max-width: 200px;
        }

        th:nth-child(3),
        td:nth-child(3) {
          width: auto;
        }

        th:nth-child(4),
        td:nth-child(4) {
          width: auto;
        }

        th:nth-child(5),
        td:nth-child(5),
        td.validity-cell {
          width: 260px;
          max-width: 260px;
          overflow: visible;
          text-overflow: clip;
          white-space: nowrap;
        }

        th {
          background-color: #F9FAFB;
          color: #333;
          font-weight: bold;
        }

        td {
          color: #666;

          &.report-name {
            color: #16a34a;

            .report-link {
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #16a34a;
              text-decoration: none;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
                color: #15803d;
              }
            }
          }

          &.standard {
            color: #16a34a;

            .standard-link {
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #16a34a;
              text-decoration: none;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
                color: #15803d;
              }
            }
          }
        }

        tr:hover td {
          background-color: #f9fafb;
        }
      }

      .results-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        margin-top: 20px;

        .page-btn {
          width: 36px;
          height: 36px;
          border: 1px solid #e5e7eb;
          background: white;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s;
          color: #6b7280;

          &:hover:not(:disabled) {
            border-color: #16a34a;
            color: #16a34a;
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          svg {
            width: 16px;
            height: 16px;
          }
        }

        .page-num {
          min-width: 36px;
          height: 36px;
          padding: 0 8px;
          border: 1px solid #e5e7eb;
          background: white;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s;
          color: #6b7280;
          font-size: 14px;

          &:hover {
            border-color: #16a34a;
            color: #16a34a;
          }

          &.active {
            background: #16a34a;
            border-color: #16a34a;
            color: white;
          }
        }
      }

      @media (max-width: 768px) {
        .results-table-wrap {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: thin;
        }

        .results-table {
          table-layout: auto;
          width: max-content;
          min-width: 100%;

          th,
          td {
            padding: 10px 12px;
            font-size: 13px;
            white-space: nowrap;
          }

          th:nth-child(1),
          td:nth-child(1) {
            width: auto;
            max-width: none;
            min-width: 120px;
          }

          th:nth-child(2),
          td:nth-child(2) {
            width: 160px;
            min-width: 160px;
            max-width: 160px;
          }

          th:nth-child(3),
          td:nth-child(3) {
            width: auto;
            max-width: none;
            min-width: 100px;
          }

          th:nth-child(4),
          td:nth-child(4) {
            width: auto;
            max-width: none;
            min-width: 120px;
          }

          th:nth-child(5),
          td:nth-child(5),
          td.validity-cell {
            width: auto;
            max-width: none;
            min-width: 260px;
          }
        }
      }

      // 加载、错误和空状态
      .loading-state,
      .error-state,
      .empty-state {
        text-align: center;
        padding: 40px 20px;

        p {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 15px;
        }

        button {
          padding: 10px 25px;
          background: #16a34a;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;

          &:hover {
            background: #15803d;
          }
        }
      }
    }
  }

  .card-wrapper {
    .report-search-box {
      margin-bottom: 0;
      padding: 0 0 40px;
      border-bottom: 1px solid #e5e7eb;
      background: transparent;
      border: none;
      box-shadow: none;
      border-radius: 0;
    }

    .report-types-part .section-title {
      margin-bottom: 28px;
    }
  }

  .report-types-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px 30px;

    .type-card {
      padding: 20px;
      text-align: left;
      transition: all 0.3s;
      cursor: pointer;
      background: lab(98.2596% -0.247031 -0.706708);
      border-radius: 12px;

      &:hover {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);

        .type-icon {
          background-color: #16a34a;
          transform: scale(1.05);

          ::v-deep svg {
            color: white;
          }
        }
      }

      .type-icon {
        width: 48px;
        height: 48px;
        background-color: #dcfce7;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
        transition: all 0.3s;

        ::v-deep svg {
          width: 24px;
          height: 24px;
          color: #16a34a;
          transition: all 0.3s;
        }
      }

      h4 {
        font-size: 16px;
        color: #1f2937;
        margin-bottom: 10px;
        font-weight: 600;
      }

      p {
        font-size: 14px;
        color: #6b7280;
        line-height: 1.7;
        text-align: justify;
      }
    }
  }
}

// 卡片包装器
.card-wrapper {
  max-width: 1160px;
  margin: 0 auto;
  background: white;
  border-radius: 16px;
  padding: 35px 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #f3f4f6;
}

// 标准解读
.standards-section {
  padding: 40px 0;
  background-color: #f9fafb;

  .standards-notice {
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    border: 1px solid #bbf7d0;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 30px;

    p {
      font-size: 14px;
      color: #15803d;
      text-align: center;
      line-height: 1.6;
    }
  }

  .standards-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    .standard-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 0;

      .standard-icon {
        width: 40px;
        height: 40px;
        background-color: #dcfce7;
        border-radius: 10px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #16a34a;

        svg {
          width: 20px;
          height: 20px;
        }
      }

      span,
      .standard-item-link {
        font-size: 14px;
        color: #374151;
        line-height: 1.5;
      }

      .standard-item-link {
        color: #16a34a;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: #15803d;
          text-decoration: underline;
        }
      }
    }
  }
}

// 覆盖行业
.industries-section {
  background-color: #f9fafb;

  .industries-grid {
    display: flex;
    justify-content: space-between;
    gap: 15px;

    .industry-card {
      flex: 1;
      text-align: center;
      padding: 30px 15px;
      background: white;
      border-radius: 12px;
      border: 1px solid #f3f4f6;
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);

        .industry-icon {
          background-color: #16a34a;

          ::v-deep svg {
            color: white;
            transform: scale(1.1) translateY(-1px);
          }
        }
      }

      .industry-icon {
        width: 48px;
        height: 48px;
        background-color: #dcfce7;
        border-radius: 10px;
        margin: 0 auto 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;

        ::v-deep svg {
          width: 24px;
          height: 24px;
          color: #16a34a;
          transition: all 0.3s;
        }
      }

      span {
        font-size: 14px;
        color: #374151;
        font-weight: 500;
      }
    }
  }
}

// 价值赋能
.value-section {
  padding: 40px 0;
  background-color: #f9fafb;

  .value-cards {
    display: flex;
    gap: 20px;

    .value-card {
      flex: 1;
      background: white;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #f3f4f6;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
        transform: translateY(-4px);
      }

      .value-header {
        background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
        padding: 20px;
        color: white;

        .value-tag {
          display: inline-block;
          font-size: 12px;
          color: #dcfce7;
          background: #33B375;
          padding: 4px 10px;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        h4 {
          font-size: 16px;
          font-weight: 600;
          line-height: 1.5;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
      }

      .value-body {
        padding: 20px;

        .case-title {
          font-size: 14px;
          color: #16a34a;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .case-desc {
          font-size: 14px;
          color: #6b7280;
          line-height: 1.8;
        }
      }
    }
  }
}

// ===== 绿色采购区域 =====
.purchase-section {
  padding: 50px 0;
  background-color: #f9fafb;

  .purchase-wrapper {
    max-width: 1160px;
    margin: 0 auto;
    display: flex;
    gap: 25px;
  }

  .purchase-left {
    flex: 1;
    background: white;
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    border: 1px solid #f3f4f6;

    .section-title {
      margin-bottom: 10px;
    }

    .lifecycle-chart {
      position: relative;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;

      .lifecycle-ring {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 280px;
        height: 280px;
        margin: -140px 0 0 -140px;

        .animate-spin-ring {
          transform-origin: 200px 200px;
          animation: spin-ring 10s linear infinite;
        }
      }

      @keyframes spin-ring {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }

      .lifecycle-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;

        .center-circle {
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 10px 25px rgba(22, 163, 74, 0.3);
          border: 4px solid white;

          svg {
            width: 28px;
            height: 28px;
            margin-bottom: 4px;
          }

          .center-text {
            font-size: 14px;
            font-weight: 600;
          }
        }
      }

      .lifecycle-nodes {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 15;
        /* 与 .lifecycle-ring 中 r=140、边长 280 的圆一致：显示半径 ≈ 98px */
        --orbit-r: clamp(78px, 25vmin, 102px);

        .node {
          position: absolute;
          left: 50%;
          top: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          min-width: 56px;
          transform: translate(-50%, -50%) rotate(var(--orbit-a, 0deg)) translateX(var(--orbit-r)) rotate(calc(-1 * var(--orbit-a, 0deg)));

          .node-icon {
            width: 44px;
            height: 44px;
            background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
            border: 3px solid white;

            svg {
              width: 20px;
              height: 20px;
            }
          }

          .node-label {
            font-size: 11px;
            color: #374151;
            font-weight: 500;
            background: rgba(255, 255, 255, 0.9);
            padding: 2px 8px;
            border-radius: 12px;
            backdrop-filter: blur(4px);
          }

          &.node-top {
            --orbit-a: -90deg;
          }

          &.node-right-top {
            --orbit-a: -45deg;
          }

          &.node-right {
            --orbit-a: 0deg;
          }

          &.node-right-bottom {
            --orbit-a: 45deg;
          }

          &.node-left-bottom {
            --orbit-a: 135deg;
          }

          &.node-left {
            --orbit-a: 180deg;
          }

          &.node-left-top {
            --orbit-a: 225deg;
          }
        }
      }
    }
  }

  .purchase-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 18px;

    .purchase-banner {
      background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
      border-radius: 16px;
      padding: 24px;
      color: white;
      position: relative;
      overflow: hidden;
      min-height: 140px;
      display: flex;
      align-items: center;
      box-shadow: 0 4px 15px rgba(22, 163, 74, 0.3);

      &::before,
      &::after {
        content: '';
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.1);
      }

      &::before {
        width: 100px;
        height: 100px;
        top: -20px;
        right: -20px;
      }

      &::after {
        width: 80px;
        height: 80px;
        bottom: -15px;
        left: -15px;
      }

      p {
        font-size: 16px;
        line-height: 1.8;
        position: relative;
        z-index: 1;

        .highlight {
          color: #fef08a;
          font-weight: 600;
        }
      }
    }

    .purchase-buttons-wrapper {
      background: white;
      border-radius: 16px;
      padding: 16px;
      border: 1px solid #e5e7eb;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }

    .purchase-buttons {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .purchase-btn {
        background: white;
        border-radius: 12px;
        padding: 14px 16px;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        transition: all 0.3s;
        border: 1px solid #e5e7eb;

        &:hover {
          border-color: #86efac;
          box-shadow: 0 4px 12px rgba(22, 163, 74, 0.12);
          transform: translateY(-2px);
        }

        &.more {
          border-color: #e5e7eb;

          &:hover {
            border-color: #d1d5db;
          }
        }

        &.bg-green-1 {
          background: #f0fdf4;
          border-color: #bbf7d0;
        }

        &.bg-green-2 {
          background: #ecfdf5;
          border-color: #a7f3d0;
        }

        &.bg-green-3 {
          background: #dcfce7;
          border-color: #86efac;
        }

        &.bg-green-4 {
          background: #f9fafb;
          border-color: #e5e7eb;
        }

        .btn-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;

          svg {
            width: 20px;
            height: 20px;
          }

          &.green-light {
            background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
            color: white;
          }

          &.green {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: white;
          }

          &.green-dark {
            background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
            color: white;
          }

          &.gray {
            background: #9ca3af;
            color: white;
          }
        }

        span {
          font-size: 14px;
          color: #374151;
          font-weight: 500;
        }
      }
    }

    .purchase-footer {
      background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
      border-radius: 12px;
      padding: 16px;
      text-align: center;
      border: 1px solid #bbf7d0;
      margin-top: 43px;

      p {
        font-size: 14px;
        color: #16a34a;
        font-weight: 500;
      }
    }
  }
}

// ===== 绿色案例区域 =====
@keyframes case-spin-ring {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.case-section {
  padding: 50px 0;
  background-color: #f9fafb;

  .case-wrapper {
    max-width: 1160px;
    margin: 0 auto;
  }

  .case-content {
    display: flex;
    gap: 25px;
  }

  .case-left {
    flex: 1;
    min-width: 0;
    background: white;
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    border: 1px solid #f3f4f6;

    .section-title {
      margin-bottom: 10px;
    }

    .lifecycle-chart {
      position: relative;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;

      .lifecycle-ring {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 280px;
        height: 280px;
        margin: -140px 0 0 -140px;

        .animate-spin-ring {
          transform-origin: 200px 200px;
          animation: case-spin-ring 10s linear infinite;
        }
      }

      .lifecycle-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;

        .center-circle {
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 10px 25px rgba(22, 163, 74, 0.3);
          border: 4px solid white;

          svg {
            width: 28px;
            height: 28px;
            margin-bottom: 4px;
          }

          .center-text {
            font-size: 14px;
            font-weight: 600;
          }
        }
      }

      .lifecycle-nodes {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 15;
        --orbit-r: clamp(78px, 25vmin, 102px);

        .node {
          position: absolute;
          left: 50%;
          top: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          min-width: 56px;
          transform: translate(-50%, -50%) rotate(var(--orbit-a, 0deg)) translateX(var(--orbit-r)) rotate(calc(-1 * var(--orbit-a, 0deg)));

          .node-icon {
            width: 44px;
            height: 44px;
            background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
            border: 3px solid white;

            svg {
              width: 20px;
              height: 20px;
            }
          }

          .node-label {
            font-size: 11px;
            color: #374151;
            font-weight: 500;
            background: rgba(255, 255, 255, 0.9);
            padding: 2px 8px;
            border-radius: 12px;
            backdrop-filter: blur(4px);
          }

          &.node-top {
            --orbit-a: -90deg;
          }

          &.node-right-top {
            --orbit-a: -45deg;
          }

          &.node-right {
            --orbit-a: 0deg;
          }

          &.node-right-bottom {
            --orbit-a: 45deg;
          }

          &.node-left-bottom {
            --orbit-a: 135deg;
          }

          &.node-left {
            --orbit-a: 180deg;
          }

          &.node-left-top {
            --orbit-a: 225deg;
          }
        }
      }
    }

    .case-card {
      background: white;
      border-radius: 16px;
      padding: 0;
      height: 100%;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
      border: 1px solid #f3f4f6;

      &.dark {
        background: linear-gradient(180deg, #166534 0%, #15803d 60%, #22c55e 100%);
        color: white;

        h4 {
          color: #86efac;
          text-align: center;
          padding: 25px 20px 20px;
          font-size: 16px;
          font-weight: 500;
        }
      }

      .case-images {
        display: flex;
        gap: 12px;
        justify-content: center;
        padding: 0 20px 25px;

        .case-img-item {
          text-align: center;
          flex: 1;

          .case-img-placeholder {
            background: white;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 10px;

            .img-tag {
              font-size: 11px;
              color: #15803d;
              background: #dcfce7;
              padding: 6px 0;
              font-weight: 500;
            }

            .img-content {
              padding: 20px 15px;
              display: flex;
              align-items: center;
              justify-content: center;

              svg {
                width: 50px;
                height: 50px;
                color: #16a34a;
              }
            }
          }

          .img-label {
            font-size: 11px;
            color: rgba(255, 255, 255, 0.9);
            display: block;
            line-height: 1.5;
            padding: 0 5px;
          }
        }
      }
    }
  }

  .case-right {
    flex: 1;

    .case-info-card {
      background: white;
      border-radius: 16px;
      padding: 35px;
      height: 100%;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
      border: 1px solid #f3f4f6;
      border-left: 3px solid #22c55e;
      flex-direction: column;
      justify-content: center;
      display: flex;

      .info-header {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 20px;

        .info-icon {
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: white;

          svg {
            width: 22px;
            height: 22px;
          }
        }

        h4 {
          font-size: 18px;
          color: #166534;
          line-height: 1.5;
          font-weight: 600;
          flex: 1;
        }
      }

      .info-desc {
        font-size: 16px;
        color: #4b5563;
        line-height: 1.9;
        text-align: justify;
      }
    }
  }
}

@media (max-width: 768px) {
  .case-section .case-content {
    flex-direction: column;
  }
}

// 联系我们
.contact-section {
  padding: 0px 0px 40px 0;
  background-color: #f9fafb;

  .contact-info {
    display: flex;
    gap: 20px;

    .contact-item {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 15px;
      padding: 25px;
      background: #f0fdf4;
      border-radius: 10px;
      border: 1px solid #dcfce7;

      .contact-icon {
        width: 44px;
        height: 44px;
        background: #dcfce7;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: #16a34a;

        svg {
          width: 22px;
          height: 22px;
        }
      }

      .contact-detail {
        label {
          font-size: 14px;
          color: #6b7280;
          display: block;
          margin-bottom: 4px;
        }

        p {
          font-size: 18px;
          color: #1f2937;
          font-weight: bold;

          &.phone {
            font-size: 18px;
            letter-spacing: 0.3px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .banner-section .banner-content {
    flex-direction: column;

    .banner-left {
      width: 100%;

      .banner-slider {
        width: 100%;

        .slider-item {
          width: 100%;

          a {
            display: block;
            width: 100%;
          }
        }
      }
    }

    .banner-left .banner-slider .slider-item .slider-image .eco-image-placeholder {
      width: 100%;
      margin-bottom: 20px;
    }
  }

  .banner-section .banner-buttons-wrapper .banner-buttons {
    .tab-item {
      padding: 12px 24px;
      font-size: 14px;

      &.active::after {
        width: calc(100% - 32px);
        height: 3px;
      }
    }
  }

  .report-section .report-types-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 28px 12px;
  }

  .report-section .type-card {
    padding: 5px;
    letter-spacing: -1px;
  }

  .report-section .card-wrapper {
    padding: 35px 15px;
  }

  .standards-section .standards-list {
    grid-template-columns: 1fr;
  }

  .industries-section .industries-grid {
    flex-wrap: wrap;

    .industry-card {
      flex: 0 0 calc(33.33% - 14px);
    }
  }

  .value-section .value-cards,
  .contact-section .contact-info {
    flex-direction: column;
  }

  .search-form .form-row {
    flex-direction: column;
    align-items: stretch !important;
  }

  // 绿色采购响应式
  .purchase-section .purchase-wrapper {
    flex-direction: column;
  }

  .case-section .case-content {
    flex-direction: column;
  }
}
</style>
